// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2dWez","text":"Button_text__2EaYy","small":"Button_small__pOqRe","round":"Button_round__2Eedz","icon":"Button_icon__JxEUa"};